import React, { useState, useContext, useEffect, useRef } from 'react';
// Formulaire complet avec toutes les améliorations
// À intégrer dans votre application React

// Composant pour sélectionner le nombre de personnes
export const PersonCounter = ({ label, count, onIncrement, onDecrement, imageUrl }) => {
    return (
      <div className="flex flex-col items-center">
        <div className="rounded-full bg-[#2C3E50] mb-2 relative">
          <img src={imageUrl} alt={label} className="w-12 h-12 object-cover rounded-full" />
          <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-white border-2 border-gray-200 flex items-center justify-center">
            <span className="font-semibold text-[#87A96B]">{count}</span>
          </div>
        </div>
        <span className="font-medium mb-3 text-[#2C3E50]">{label}</span>
        <div className="flex space-x-2">
          <button 
            type="button"
            onClick={onDecrement}
            disabled={count <= 0}
            className={`w-10 h-10 rounded-full flex items-center justify-center ${count <= 0 ? 'bg-gray-300' : 'bg-[#2C3E50]'} text-white hover:bg-[#2C3E50]/90 transition-colors`}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4" />
            </svg>
          </button>
          <button 
            type="button"
            onClick={onIncrement}
            className="w-10 h-10 rounded-full flex items-center justify-center bg-[#87A96B] text-white hover:bg-[#87A96B]/90 transition-colors"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
            </svg>
          </button>
        </div>
      </div>
    );
  };

// Composant réutilisable pour les catégories avec grilles d'images
export const PreferenceCategory = ({ 
  title, 
  color, 
  items, 
  selectedItems, 
  onToggle, 
  inputName,
  cols = 2,
  otherInput = true,
  placeholder
}) => {
  const [otherValue, setOtherValue] = useState('');

  // Couleurs par type - mise à jour avec la nouvelle palette
  const colorStyles = {
    green: {
      title: "text-[#87A96B]",
      border: "border-[#87A96B]", 
      bg: "bg-[#87A96B]/10", 
      iconBg: "bg-[#87A96B]", 
      iconText: "text-[#87A96B]"
    },
    red: {
      title: "text-red-700",
      border: "border-red-500", 
      bg: "bg-red-50", 
      iconBg: "bg-red-500", 
      iconText: "text-red-600"
    },
    yellow: {
      title: "text-[#E67E22]",
      border: "border-[#E67E22]", 
      bg: "bg-[#E67E22]/10", 
      iconBg: "bg-[#E67E22]", 
      iconText: "text-[#E67E22]"
    },
    blue: {
      title: "text-[#87A96B]",
      border: "border-[#87A96B]", 
      bg: "bg-[#87A96B]/10", 
      iconBg: "bg-[#87A96B]", 
      iconText: "text-[#87A96B]"
    }
  };
  
  const styles = colorStyles[color];
  
  const handleAddOther = () => {
    const value = otherValue.trim();
    if (value && (!selectedItems || !selectedItems.includes(value))) {
      onToggle(inputName, value);
      setOtherValue('');
    }
  };

  // Fonction pour supprimer un élément sélectionné
  const handleRemoveSelected = (value) => {
    onToggle(inputName, value); // OnToggle gère l'ajout/suppression
  };

  return (
    <div className="mb-6">
      <h3 className={`text-lg font-medium mb-3 text-center ${styles.title}`}>
        {title}
      </h3>
      <div className={`grid grid-cols-${cols} md:grid-cols-${4*cols} gap-3 mb-3 w-full`}>
        {items.map((item) => (
          <div
            key={item.name}
            onClick={() => onToggle(inputName, item.name)}
            className={`flex flex-col items-center p-2 rounded-lg cursor-pointer border-2 transition-all hover:shadow-md ${
              selectedItems && selectedItems.includes(item.name)
                ? `${styles.border} ${styles.bg}`
                : "border-gray-200 bg-white hover:border-gray-300"
            }`}
            style={{ aspectRatio: '1 / 1' }} // Make the element square
          >
            <div className="relative w-full h-0 pb-[100%] mb-1"> {/* Square container */}
              {item.img ? (
                <img 
                  src={item.img}
                  alt={item.name}
                  className="absolute top-0 left-0 w-full h-full object-cover rounded-lg"
                />
              ) : (
                <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center text-2xl">
                  {item.icon}
                </div>
              )}
              
              <span className="absolute top-1 right-1 text-lg">{item.icon}</span>
              
              {selectedItems && selectedItems.includes(item.name) && (
                <div className={`absolute top-0 right-0 bottom-0 left-0 ${styles.iconBg} bg-opacity-20 rounded-lg flex items-center justify-center`}>
                  {color === "red" || color === "yellow" ? (
                    <svg xmlns="http://www.w3.org/2000/svg" className={`h-8 w-8 ${styles.iconText}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  ) : (
                    <svg xmlns="http://www.w3.org/2000/svg" className={`h-8 w-8 ${styles.iconText}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  )}
                </div>
              )}
            </div>
            <span className="text-xs font-medium text-center text-[#2C3E50]">{item.name}</span>
            {item.desc && <span className="text-xs text-gray-500">{item.desc}</span>}
          </div>
        ))}
      </div>
      {selectedItems && selectedItems.length > 0 && (
        <div className={`grid grid-cols-${cols} md:grid-cols-${4*cols} gap-3 mb-3 w-full`}>
          {selectedItems
            .filter(item => items.map((x) => x.name).indexOf(item) === -1)
            .map((item) => (
              <div
                key={item}
                onClick={() => handleRemoveSelected(item)}
                className={`flex flex-col items-center p-2 rounded-lg border-2 ${styles.border} ${styles.bg} relative cursor-pointer hover:opacity-80 transition-opacity`}
                title="Cliquer pour supprimer"
                style={{ aspectRatio: '1 / 1' }} // Make the element square
              >
                <div className="flex items-center justify-center h-full w-full mb-1">
                  <span className="text-2xl font-bold text-[#2C3E50]">{item[0]?.toUpperCase()}</span>
                </div>
                <span className="text-xs font-medium text-center break-all text-[#2C3E50]">{item}</span>
              </div>
            ))}
        </div>
      )}
      {otherInput && (
        <div className="flex items-center gap-2">
          <input
            type="text"
            value={otherValue}
            onChange={e => setOtherValue(e.target.value)}
            placeholder={placeholder}
            className="flex-grow p-3 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-[#87A96B] focus:border-[#87A96B] transition-colors"
            onKeyDown={e => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  handleAddOther();
                }
              }}
          />
          <button
            type="button"
            onClick={handleAddOther}
            className="bg-[#87A96B] text-white px-3 py-2 rounded-lg hover:bg-[#87A96B]/90 transition-colors text-lg font-medium"
            title="Ajouter"
          >
            +
          </button>
        </div>
      )}
    </div>
  );
};

// Liste d'ingrédients pour l'autocomplétion (peut être déplacée vers une API ou un fichier séparé)

export const IngredientsSelector = ({ onChange, ingredientsList, initialSelected = []  }) => {
  const [inputValue, setInputValue] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const [filteredIngredients, setFilteredIngredients] = useState([]);
  const [selectedIngredients, setSelectedIngredients] = useState(initialSelected);
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);

  // Filtrer les ingrédients selon l'entrée de l'utilisateur
  useEffect(() => {
    if (inputValue.trim() === '') {
      setFilteredIngredients([]);
      setShowDropdown(false);
      return;
    }
    
    // S'assurer que ingredientsList existe et est un tableau
    if (Array.isArray(ingredientsList) && ingredientsList.length > 0) {
      const filtered = ingredientsList
        .filter(ingredient => 
          ingredient.toLowerCase().includes(inputValue.toLowerCase()) && 
          !selectedIngredients.includes(ingredient)
        )
        .slice(0, 10); // Limiter à 10 suggestions
      
      setFilteredIngredients(filtered);
      setShowDropdown(filtered.length > 0);
    }
  }, [inputValue, selectedIngredients, ingredientsList]); // Ajout d'ingredientsList aux dépendances

  // Fermer le dropdown si on clique ailleurs
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) &&
          inputRef.current && !inputRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const addIngredient = (ingredient = null) => {
    const newIngredient = ingredient || inputValue.trim();
    if (newIngredient && !selectedIngredients.includes(newIngredient)) {
      const newList = [...selectedIngredients, newIngredient];
      setSelectedIngredients(newList);
      setInputValue('');
      setShowDropdown(false);
      if (onChange) onChange(newList); // Appel direct ici
    }
  };

  const removeIngredient = (ingredient) => {
    const newList = selectedIngredients.filter(item => item !== ingredient);
    setSelectedIngredients(newList);
    if (onChange) onChange(newList); // Appel direct ici
  };

  return (
    <div className="w-full">
      {/* Affichage des ingrédients sélectionnés */}
      <div className="flex flex-wrap gap-2 mb-3">
        {selectedIngredients.map(ingredient => (
          <div key={ingredient} className="bg-[#87A96B]/10 border border-[#87A96B]/30 px-3 py-1 rounded-full flex items-center">
            <span className="text-[#2C3E50]">{ingredient}</span>
            <button 
              onClick={() => removeIngredient(ingredient)}
              className="ml-2 text-gray-500 hover:text-red-500 transition-colors"
            >
              ×
            </button>
          </div>
        ))}
      </div>
      
      {/* Champ de saisie avec bouton "Ajouter" qui place l'ingrédient dans la liste en haut */}
      <div className="relative flex">
        <input
          ref={inputRef}
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          placeholder="Ex: Champignons, olives..."
          className="flex-grow p-3 border border-gray-300 rounded-l-lg focus:ring-2 focus:ring-[#87A96B] focus:border-[#87A96B] transition-colors"
          onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault(); // si tu veux empêcher le submit d'un form
                addIngredient();    // ta logique personnalisée ici
              }
            }}
          onFocus={() => {
            if (inputValue.trim() !== '' && filteredIngredients.length > 0) {
              setShowDropdown(true);
            }
          }}
        />
        <button
          type="button" 
          onClick={(e) => {
            e.preventDefault(); // Empêche la soumission du formulaire
            addIngredient();
          }}
          className="bg-[#87A96B] text-white px-4 rounded-r-lg hover:bg-[#87A96B]/90 transition-colors font-medium"
        >
          Ajouter
        </button>
      </div>
      
      {/* Dropdown pour l'autocomplétion */}
      {showDropdown && (
        <div 
          ref={dropdownRef}
          className="absolute z-10 mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-y-auto"
        >
          {filteredIngredients.map((ingredient, index) => (
            <div
              key={index}
              className="p-2 hover:bg-[#87A96B]/10 cursor-pointer transition-colors text-[#2C3E50]"
              onClick={() => addIngredient(ingredient)}
            >
              {ingredient}
            </div>
          ))}
        </div>
      )}
      
      <p className="text-sm text-gray-500 mt-2">
        Commencez à taper pour voir des suggestions, cliquez sur une suggestion ou utilisez le bouton OK pour ajouter l'ingrédient à votre liste
      </p>
    </div>
  );
};